import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
} from "@mui/material";
import HourglassDisabledIcon from "@mui/icons-material/HourglassDisabled";
import { useSession } from "context/SessionContext";
import logoutAndRedirect from "utils/logoutHelper";

export default function SessionExpiredDialog() {
  const { sessionExpired, dismissSessionExpired } = useSession();

  const handleLoginAgain = () => {
    dismissSessionExpired();
    logoutAndRedirect();
  };

  return (
    <Dialog
      open={sessionExpired}
      onClose={(_e, reason) => {
        // Don't allow dismissing by clicking outside or pressing Escape —
        // the user must explicitly confirm they want to log in again.
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
      }}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2, p: 1 },
      }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            bgcolor: "warning.light",
            color: "warning.dark",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <HourglassDisabledIcon />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Session expired
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          Your session has expired for an inactivity on portal. Please log in again to continue.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleLoginAgain}
          sx={{ color: "#fff", textTransform: "none", fontWeight: 600 }}
        >
          Log in again
        </Button>
      </DialogActions>
    </Dialog>
  );
}
